webpackJsonp([1],{

/***/ 102:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

Object.defineProperty(SVGElement.prototype, 'outerHTML', {
  get: function get() {
    var $node;
    var $temp;
    $temp = document.createElement('div');
    $node = this.cloneNode(true);
    $temp.appendChild($node);
    return $temp.innerHTML;
  },
  enumerable: false,
  configurable: true
});

Object.defineProperty(window.Node.prototype, 'children', {
  get: function get() {
    var i = 0;
    var node;
    var nodes = this.childNodes;
    var children = [];

    node = nodes[i];

    while (node) {
      if (node.nodeType === 1) {
        children.push(node);
      }
      node = nodes[i++];
    }
    return children;
  }
});

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(80)

var Component = __webpack_require__(98)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(99),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_opentype_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_opentype_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_opentype_js__);





var LogoMaker = function () {
  function LogoMaker(params) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LogoMaker);

    this.fontUrl = params.fontUrl;
    this.svgSize = params.svgSize;
    this.textSize = params.textSize;
    this.text = params.text || '';
    this.textColor = params.textColor;
    this.fontFamily = params.fontFamily || 'Arial';
    this.position = params.position || 'left';
    this.iconSize = params.iconSize;
    this.iconSVG = params.iconSVG;
    this.iconScale = params.iconScale;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LogoMaker, [{
    key: 'make',
    value: function make() {
      return this.createSVG();
    }
  }, {
    key: 'createSVG',
    value: function createSVG() {
      var _this = this;

      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('width', this.svgSize.width + 5);
      svg.setAttribute('height', this.svgSize.height + 5);

      return this.loadFont(this.fontFamily).then(function (font) {
        return _this.addText(svg, font, _this.text);
      }).then(function () {
        return _this.addIcon(svg);
      }).then(function () {
        return svg;
      });
    }
  }, {
    key: 'getIconCoords',
    value: function getIconCoords() {
      var x = 0;
      var y = 0;
      var iconSize = this.iconSVG.getBBox();

      if (this.position === 'left' || this.position === 'right') {
        y = -iconSize.y * this.iconScale + (this.svgSize.height / 2 - iconSize.height * this.iconScale / 2);
      } else if (this.position === 'bottom') {
        y = -iconSize.y + this.svgSize.height - iconSize.height * this.iconScale + 5;
      }

      if (this.position === 'top' || this.position === 'bottom') {
        x = this.svgSize.width / 2 - iconSize.width * this.iconScale / 2 - iconSize.x * this.iconScale;
      } else if (this.position === 'right') {
        x = this.svgSize.width - iconSize.x - iconSize.width * this.iconScale;
      } else {
        x = -iconSize.x * this.iconScale;
      }

      return {
        x: x,
        y: y
      };
    }
  }, {
    key: 'addIcon',
    value: function addIcon(svg) {
      var g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      g.innerHTML = this.iconSVG.innerHTML;
      g.setAttribute('fill', this.iconSVG.getAttribute('fill'));
      svg.appendChild(g);

      var coords = this.getIconCoords();
      g.setAttribute('transform', 'matrix(' + this.iconScale + ', 0, 0, ' + this.iconScale + ', ' + coords.x + ', ' + coords.y + ')');

      return true;
    }
  }, {
    key: 'getTextCoords',
    value: function getTextCoords() {
      var x = 0;
      var y = 0;

      if (this.position === 'left' || this.position === 'right') {
        y = this.svgSize.height / 2 + this.textSize.height / 2 + this.iconScale - 5;
      } else if (this.position === 'top') {
        y = this.svgSize.height - 5;
      } else if (this.position === 'bottom') {
        y = this.textSize.height - 5;
      }

      if (this.position === 'left') {
        x = this.svgSize.width - this.textSize.width - 3;
      }

      return {
        x: x,
        y: y
      };
    }
  }, {
    key: 'addText',
    value: function addText(svg, font, text) {
      var coords = this.getTextCoords();
      svg.innerHTML = font.getPath(text, coords.x, coords.y, 32).toSVG();
      svg.querySelector('path').setAttribute('fill', this.textColor);
      return true;
    }
  }, {
    key: 'loadFont',
    value: function loadFont(fontName) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_bluebird___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3_opentype_js___default.a.load(_this2.fontUrl, function (err, font) {
          if (err) {
            reject(err);
          } else {
            resolve(font);
          }
        });
      });
    }
  }]);

  return LogoMaker;
}();

/* harmony default export */ __webpack_exports__["a"] = (LogoMaker);

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_innersvg_polyfill__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_innersvg_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_innersvg_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_closest__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_closest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_closest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_custom_event_polyfill__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_custom_event_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_custom_event_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__polyfills__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__polyfills___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__polyfills__);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debounce__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_color__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_webfontloader__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_webfontloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_webfontloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logomaker__ = __webpack_require__(43);









var iconsCache = {};

var shapes = ['none', 'Shape_-01', 'Shape_-02', 'Shape_-03', 'Shape_-04', 'Shape_-05', 'Shape_-06', 'Shape_-07', 'Shape_-08', 'Shape_-09', 'Shape_-10', 'Shape_-11', 'Shape_-12', 'Shape_-13', 'Shape_-14', 'Shape_-15', 'Shape_-17', 'Shape_-18', 'Shape_-19', 'Shape_-20', 'Shape_-21', 'Shape_-22', 'Shape_-23', 'Shape_-24', 'Shape_-25'];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  mounted: function mounted() {
    var _this = this;

    this.ready();

    if (window.addEventListener) {
      window.addEventListener('resize', function () {
        _this.computeWorkareaSize();
        _this.textAlign();
        _this.iconAlign();
      });
    } else if (window.attachEvent) {
      window.attachEvent('onresize', function () {
        _this.computeWorkareaSize();
        _this.textAlign();
        _this.iconAlign();
      });
    }
  },
  data: function data() {
    return {
      isReady: false,

      workareaSize: undefined,

      fonts: [],
      text: 'Logo•Laba',
      textTransform: '',
      textColors: {},
      textColor: '',
      textStyle: {
        fontSize: '32px',
        fontFamily: 'Lobster'
      },
      textBold: false,
      textItalic: false,

      themes: {},
      theme: 'education',
      icons: [],
      icon: '',
      iconHTML: '',
      iconSize: { width: 0, height: 0 },
      iconScale: 1,
      iconPosition: 'top',
      iconTransform: '',
      iconColors: {},
      iconColor: '#D0021B',

      toolbox: '',

      shapes: shapes,
      shape: 'none',
      shapePath: ''
    };
  },


  methods: {
    ready: function ready() {
      var _this2 = this;

      return this.$http.get('static/themes.json').then(function (response) {
        _this2.themes = response.data;
        return _this2.themes;
      }).then(function () {
        return __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.all([_this2.loadIcons(), _this2.loadFonts()]);
      }).then(function () {
        _this2.textStyle.fontFamily = _this2.fonts[0].name;
        return _this2.waitFont(_this2.textStyle.fontFamily);
      }).then(this.computeWorkareaSize).then(this.textAlign).then(function () {
        _this2.icon = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.icons)[0];
        return _this2.waitIcon(_this2.icon);
      }).then(function () {
        return new __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a(function (resolve) {
          setTimeout(function () {
            _this2.isReady = true;
            _this2.listenToolboxClose();
            resolve(_this2.isReady);
          }, 300);
        });
      });
    },
    computeWorkareaSize: function computeWorkareaSize() {
      var workarea = this.$el.querySelector('.logo-maker-workarea');
      this.workareaSize = {
        width: workarea.clientWidth,
        height: workarea.clientHeight
      };

      return workarea;
    },
    textAlign: function textAlign() {
      var x = this.workareaSize.width / 2;
      var y = this.workareaSize.height / 2;
      var scale = this.getResize();
      this.textTransform = 'matrix(' + scale + ', 0, 0, ' + scale + ', ' + x + ', ' + y + ')';

      return this.textTransform;
    },
    getTextSize: function getTextSize() {
      var text = this.$el.querySelector('.logo-maker-workarea text');
      var width = 0;
      var height = 0;

      if (text) {
        width = text.getBoundingClientRect().width;
        height = text.getBoundingClientRect().height;
      }

      return {
        width: width,
        height: height
      };
    },
    getTextPosition: function getTextPosition() {
      var workarea = this.$el.querySelector('.logo-maker-workarea');
      var text = workarea.querySelector('.logo-maker-workarea text');

      var position = {
        left: 0,
        top: 0
      };
      if (workarea && text) {
        position.left = text.getBoundingClientRect().left - workarea.getBoundingClientRect().left;
        position.top = text.getBoundingClientRect().top - workarea.getBoundingClientRect().top;
      }

      return position;
    },


    iconAlign: __WEBPACK_IMPORTED_MODULE_2_debounce___default()(function () {
      var textSize = this.getTextSize();
      var textPosition = this.getTextPosition();
      var iconScale = this.iconScale * this.getResize();
      var iconHeight = this.iconSize.height * iconScale;
      var iconWidth = this.iconSize.width * iconScale;
      var x = 0;
      var y = 0;

      if (this.hasShape()) {
        iconHeight += 28 * this.iconScale;
        iconWidth += 28 * this.iconScale;
      }

      if (this.iconPosition === 'left' || this.iconPosition === 'right') {
        var diff = textSize.height - iconHeight;
        y = textPosition.top + diff / 2 - 6 * iconScale;
      } else if (this.iconPosition === 'top') {
        y = textPosition.top - iconHeight - 2 * iconScale;
      } else if (this.iconPosition === 'bottom') {
        y = textPosition.top + textSize.height + 2 * iconScale;
      }

      if (this.iconPosition === 'top' || this.iconPosition === 'bottom') {
        x = textPosition.left + textSize.width / 2 - iconWidth + iconWidth / 2;
      } else if (this.iconPosition === 'left') {
        x = textPosition.left - iconWidth - 10;
      } else if (this.iconPosition === 'right') {
        x = textPosition.left + textSize.width + 10;
      }

      this.iconTransform = 'matrix(' + iconScale + ', 0, 0, ' + iconScale + ', ' + x + ', ' + y + ')';

      return true;
    }, 100),

    loadIcons: function loadIcons(theme) {
      var _this3 = this;

      theme = theme || this.theme;
      return this.$http.get('static/icons/' + theme + '.json').then(function (response) {
        _this3.icons = response.body;
      });
    },
    loadIcon: function loadIcon(icon) {
      return this.$http.get(this.getIconUrl(icon)).then(function (response) {
        return response.data;
      });
    },
    getIconUrl: function getIconUrl(icon) {
      return this.icons[icon];
    },
    prepareIcon: function prepareIcon(iconHTML) {
      var size;

      var iconWrap = document.createElement('div');
      iconWrap.style.visibility = 'hidden';
      iconWrap.style.position = 'absolute';
      iconWrap.style.left = '-9999px';
      iconWrap.innerHTML = iconHTML;

      var iconElement = iconWrap.querySelector('svg');


      iconElement.setAttribute('width', 64);
      iconElement.setAttribute('height', 64);

      size = {
        width: 64,
        height: 64 };


      return {
        html: iconWrap.innerHTML,
        size: size
      };
    },
    loadFonts: function loadFonts() {
      var _this4 = this;

      return this.$http.get('static/fonts.json').then(function (response) {
        _this4.fonts = response.body;
      });
    },
    waitFont: function waitFont(font) {
      return new __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_4_webfontloader___default.a.load({
          google: {
            families: [font + ':regular,bold,italic,bolditalic']
          },
          active: function active() {
            resolve(font);
          }
        });
      }).then(function () {
        return font;
      });
    },
    changeFont: function changeFont(test) {
      var _this5 = this;

      this.waitFont(this.textStyle.fontFamily).then(function () {
        _this5.textBold = false;
        _this5.textItalic = false;
        _this5.iconAlign();
      });
    },
    addFontStyle: function addFontStyle(font) {
      var styleText = '@font-face { font-family: ' + font + '; src:url(static/fonts/' + font + '/' + font + '.ttf); font-weight: normal;font-style: normal;}';
      var styleNode = document.createElement('style');
      styleNode.type = 'text/css';
      if (window.attachEvent || window.opera) {
        styleNode.styleSheet.cssText = styleText;
      } else {
        var style = document.createTextNode(styleText);
        styleNode.appendChild(style);
      }

      document.head.appendChild(styleNode);

      return font;
    },


    changeColorText: __WEBPACK_IMPORTED_MODULE_2_debounce___default()(function (val) {
      this.textColor = val.hex;
    }, 250),

    changeColorIcon: __WEBPACK_IMPORTED_MODULE_2_debounce___default()(function (val) {
      this.iconColor = val.hex;
    }, 250),

    listenToolboxClose: function listenToolboxClose() {
      var _this6 = this;

      var workarea = document.querySelector('.logo-maker-workarea-wrap');

      var listener = function listener(event) {
        if (_this6.toolbox) {
          _this6.toolbox = '';
        }
      };

      workarea.removeEventListener('click', listener);
      setTimeout(function () {
        workarea.addEventListener('click', listener);
        document.addEventListener('keyup', function (event) {
          if (event.keyCode === 27) {
            listener(event);
          }
        });
      }, 100);
    },
    openToolbox: function openToolbox(toolbox) {
      this.toolbox = toolbox;
    },
    waitIcon: function waitIcon(icon) {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a(function (resolve) {
        if (iconsCache[icon]) {
          _this7.iconSize = iconsCache[icon]['size'];
          _this7.iconAlign();
          _this7.iconHTML = iconsCache[icon]['html'];
          resolve(icon);
        } else {
          _this7.loadIcon(icon).then(_this7.prepareIcon).then(function (data) {
            _this7.iconSize = data.size;
            _this7.iconAlign();
            _this7.iconHTML = data.html;

            iconsCache[icon] = data;

            resolve(icon);
          });
        }
      });
    },
    hasShape: function hasShape() {
      return this.shape !== 'none';
    },
    loadShape: function loadShape(shape) {
      return this.$http.get('static/shapes/' + shape + '.svg').then(function (response) {
        return response.body;
      }).then(this.getShapePath);
    },
    getShapePath: function getShapePath(shapeSVG) {
      var shapeWrap = document.createElement('div');
      shapeWrap.innerHTML = shapeSVG;
      return shapeWrap.querySelector('svg').children[0].outerHTML;
    },
    getLogo: function getLogo() {
      var resize = this.getResize();
      var svgInner = this.$el.querySelector('.logo-maker-svg__inner');
      var svgSize = {
        width: svgInner.getBBox().width,
        height: svgInner.getBBox().height
      };
      var textSize = svgInner.querySelector('text').getBBox();

      svgSize.width = svgSize.width / resize;
      svgSize.height = svgSize.height / resize;

      if (this.iconPosition === 'top' && this.iconPosition && resize !== 1) {
        svgSize.height -= 10 * this.iconScale;
      }

      var fontUrl = this.font.Regular;

      if (this.textBold && this.textItalic && this.font.BoldItalic) {
        fontUrl = this.font.BoldItalic;
      } else if (this.textBold && this.font.Bold) {
        fontUrl = this.font.Bold;
      } else if (this.textItalic && this.font.Italic) {
        fontUrl = this.font.Italic;
      }
      var params = {
        svgSize: svgSize,
        textSize: textSize,
        text: this.text,
        textColor: this.textColor,
        fontFamily: this.textStyle.fontFamily,
        fontUrl: fontUrl,
        position: this.iconPosition,
        iconSVG: svgInner.querySelector('.icon-wrap'),
        iconScale: parseFloat(this.iconScale)
      };
      var logo = new __WEBPACK_IMPORTED_MODULE_5__logomaker__["a" /* default */](params);

      logo.make().then(function (svg) {
        var event = {};
        if (window.CustomEvent) {
          event = new CustomEvent('get-logo', {
            detail: {
              svg: svg.outerHTML
            }
          });
        } else {
          event = document.createEvent('CustomEvent');
          event.initCustomEvent('get-logo', true, true, { svg: svg.outerHTML });
        }

        window.document.dispatchEvent(event);
      });
    },
    getResize: function getResize() {
      return window.innerWidth > 768 ? 1 : 0.7;
    }
  },

  watch: {
    icon: function icon() {
      if (!this.isReady || this.icon === '') {
        return;
      }
      this.waitIcon(this.icon);
    },
    text: function text() {
      this.iconAlign();
    },
    iconScale: function iconScale() {
      this.iconAlign();
    },
    iconPosition: function iconPosition() {
      this.iconAlign();
    },
    shape: function shape(val) {
      var _this8 = this;

      if (this.hasShape()) {
        this.loadShape(val).then(function (shapePath) {
          _this8.shapePath = shapePath;
        });
      } else {
        this.shapePath = '';
      }
    },
    shapePath: function shapePath() {
      this.iconAlign();
    },
    theme: function theme(_theme) {
      this.loadIcons(_theme);
    }
  },

  computed: {
    font: function font() {
      var _this9 = this;

      if (!this.isReady || this.fonts.length < 1) {
        return {};
      }

      var selectedFont = {};

      this.fonts.forEach(function (font) {
        if (font.name === _this9.textStyle.fontFamily) {
          selectedFont = font;
        }
      });

      return selectedFont;
    }
  },

  components: {
    'sketch-picker': __WEBPACK_IMPORTED_MODULE_3_vue_color__["Sketch"]
  }
});

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-maker-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReady),
      expression: "!isReady"
    }],
    staticClass: "logo-maker-loader"
  }, [_c('div', {
    staticClass: "loader"
  })]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker",
    style: ({
      visibility: _vm.isReady ? 'visible' : 'hidden'
    })
  }, [_c('div', {
    staticClass: "logo-maker-menu"
  }, [_c('div', {
    staticClass: "logo-maker-menu__item"
  }, [_c('label', {
    staticClass: "logo-maker-menu__label",
    attrs: {
      "for": "logoMakerText"
    }
  }, [_vm._v("Название вашей фирмы")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "logo-maker-menu__form-control",
    attrs: {
      "id": "logoMakerText",
      "type": "text",
      "placeholder": "Название вашей фирмы"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "focus": function($event) {
        _vm.openToolbox('text')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toolbox === 'text'),
      expression: "toolbox === 'text'"
    }],
    staticClass: "logo-maker-toolbox",
    attrs: {
      "id": "textToolbox"
    }
  }, [_c('sketch-picker', {
    on: {
      "change-color": _vm.changeColorText
    },
    model: {
      value: (_vm.textColors),
      callback: function($$v) {
        _vm.textColors = $$v
      },
      expression: "textColors"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-toolbox__close",
    on: {
      "click": function($event) {
        _vm.toolbox = ''
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 64 64",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "enable-background": "new 0 0 64 64"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M28.941,31.786L0.613,60.114c-0.787,0.787-0.787,2.062,0,2.849c0.393,0.394,0.909,0.59,1.424,0.59   c0.516,0,1.031-0.196,1.424-0.59l28.541-28.541l28.541,28.541c0.394,0.394,0.909,0.59,1.424,0.59c0.515,0,1.031-0.196,1.424-0.59   c0.787-0.787,0.787-2.062,0-2.849L35.064,31.786L63.41,3.438c0.787-0.787,0.787-2.062,0-2.849c-0.787-0.786-2.062-0.786-2.848,0   L32.003,29.15L3.441,0.59c-0.787-0.786-2.061-0.786-2.848,0c-0.787,0.787-0.787,2.062,0,2.849L28.941,31.786z"
    }
  })])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-menu__item"
  }, [_c('label', {
    staticClass: "logo-maker-menu__label",
    attrs: {
      "for": "logoMakerFont"
    }
  }, [_vm._v("\n          Шрифт названия\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-menu__fontstyle"
  }, [_c('label', {
    staticClass: "logo-maker-menu__fontstyle-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textBold),
      expression: "textBold"
    }],
    staticClass: "logo-maker-menu__fontstyle-checkbox",
    attrs: {
      "type": "checkbox",
      "disabled": !(_vm.font.Bold && (_vm.textItalic ? _vm.font.BoldItalic : true))
    },
    domProps: {
      "checked": Array.isArray(_vm.textBold) ? _vm._i(_vm.textBold, null) > -1 : (_vm.textBold)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.textBold,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.textBold = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.textBold = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.textBold = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "logo-maker-menu__fontstyle-icon"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "width": "16px",
      "height": "16px",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 16 16",
      "enable-background": "new 0 0 16 16",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M10.3,7.8c0.8,0.2,2.2,0.5,2.2,2c0,0.6-0.2,1.1-0.7,1.5c-0.6,0.5-1.4,0.7-2.6,0.7h-4v-0.2c0.4,0,0.6,0,0.7-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.4,0.1-0.8V5.4c0-0.4,0-0.7-0.1-0.8C6.2,4.5,6.1,4.4,6,4.4C5.8,4.3,5.6,4.3,5.2,4.3V4H9C10,4,10.6,4.1,11,4.3c0.4,0.2,0.7,0.4,0.9,0.7c0.2,0.3,0.3,0.7,0.3,1c0,0.4-0.1,0.7-0.4,1C11.5,7.4,11,7.6,10.3,7.8z M8.2,8.1l0,2.8c0,0.2,0.1,0.4,0.2,0.5s1.1,0,1.3,0c1-0.2,1.5-2.2,0.2-2.9C9.6,8.3,8.8,8.1,8.2,8.1z M8.2,7.6c0.6,0,1.9-0.2,1.9-1.2c0-2-1-1.9-1.9-1.9V7.6z"
    }
  })])])])]), _vm._v(" "), _c('label', {
    staticClass: "logo-maker-menu__fontstyle-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textItalic),
      expression: "textItalic"
    }],
    staticClass: "logo-maker-menu__fontstyle-checkbox",
    attrs: {
      "type": "checkbox",
      "disabled": !(_vm.font.Italic && (_vm.textBold ? _vm.font.BoldItalic : true))
    },
    domProps: {
      "checked": Array.isArray(_vm.textItalic) ? _vm._i(_vm.textItalic, null) > -1 : (_vm.textItalic)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.textItalic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.textItalic = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.textItalic = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.textItalic = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "logo-maker-menu__fontstyle-icon"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "width": "16px",
      "height": "16px",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 16 16",
      "enable-background": "new 0 0 16 16",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M8.3,11.8L8.3,12H5l0.1-0.2c0.3,0,0.5,0,0.6-0.1c0.2-0.1,0.3-0.2,0.4-0.3c0.1-0.2,0.3-0.5,0.4-1l1.4-4.8C8,5.3,8.1,5,8.1,4.8c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.3-0.1-0.6-0.1l0.1-0.2h3.1l-0.1,0.2c-0.2,0-0.4,0-0.6,0.1C9.5,4.4,9.3,4.6,9.3,4.7C9.2,4.8,9,5.2,8.9,5.7l-1.4,4.8c-0.1,0.4-0.2,0.7-0.2,0.8c0,0.1,0,0.2,0.1,0.2c0,0.1,0.1,0.1,0.2,0.2C7.8,11.7,8,11.8,8.3,11.8z"
    }
  })])])])])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textStyle.fontFamily),
      expression: "textStyle.fontFamily"
    }],
    staticClass: "logo-maker-menu__form-control",
    attrs: {
      "id": "logoMakerFont",
      "type": "text",
      "placeholder": "Шрифт названия"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.textStyle.fontFamily = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        $event.stopPropagation();
        _vm.changeFont(this)
      }]
    }
  }, _vm._l((_vm.fonts), function(font) {
    return _c('option', [_vm._v(_vm._s(font.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-menu__item"
  }, [_c('label', {
    staticClass: "logo-maker-menu__label",
    attrs: {
      "for": "logoMakerTheme"
    }
  }, [_vm._v("Тематика")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theme),
      expression: "theme"
    }],
    staticClass: "logo-maker-menu__form-control",
    attrs: {
      "id": "logoMakerTheme",
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.theme = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.themes), function(name, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(" " + _vm._s(name) + " ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-menu__item"
  }, [_c('label', {
    staticClass: "logo-maker-menu__label",
    attrs: {
      "for": "logoMakerIcon"
    }
  }, [_vm._v("Иконка")]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-icons"
  }, _vm._l((_vm.icons), function(url, i) {
    return _c('div', {
      staticClass: "logo-maker-icons__item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.icon),
        expression: "icon"
      }],
      staticClass: "logo-maker-icons__radio",
      attrs: {
        "type": "radio",
        "id": 'logoMakerIcon_' + i
      },
      domProps: {
        "value": i,
        "checked": _vm._q(_vm.icon, i)
      },
      on: {
        "__c": function($event) {
          _vm.icon = i
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "logo-maker-icons__icon",
      attrs: {
        "for": 'logoMakerIcon_' + i
      },
      on: {
        "click": function($event) {
          _vm.openToolbox('icon')
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": "",
        "src": _vm.getIconUrl(i),
        "width": "32",
        "height": "32"
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toolbox === 'icon'),
      expression: "toolbox === 'icon'"
    }],
    staticClass: "logo-maker-toolbox",
    attrs: {
      "id": "icnToolbox"
    }
  }, [_c('sketch-picker', {
    on: {
      "change-color": _vm.changeColorIcon
    },
    model: {
      value: (_vm.iconColors),
      callback: function($$v) {
        _vm.iconColors = $$v
      },
      expression: "iconColors"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-toolbox__close",
    on: {
      "click": function($event) {
        _vm.toolbox = ''
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 64 64",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "enable-background": "new 0 0 64 64"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M28.941,31.786L0.613,60.114c-0.787,0.787-0.787,2.062,0,2.849c0.393,0.394,0.909,0.59,1.424,0.59   c0.516,0,1.031-0.196,1.424-0.59l28.541-28.541l28.541,28.541c0.394,0.394,0.909,0.59,1.424,0.59c0.515,0,1.031-0.196,1.424-0.59   c0.787-0.787,0.787-2.062,0-2.849L35.064,31.786L63.41,3.438c0.787-0.787,0.787-2.062,0-2.849c-0.787-0.786-2.062-0.786-2.848,0   L32.003,29.15L3.441,0.59c-0.787-0.786-2.061-0.786-2.848,0c-0.787,0.787-0.787,2.062,0,2.849L28.941,31.786z"
    }
  })])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-menu__item"
  }, [_c('div', {
    staticClass: "logo-maker-menu__half",
    staticStyle: {
      "width": "65%"
    }
  }, [_c('label', {
    staticClass: "logo-maker-menu__label",
    attrs: {
      "for": "logoMakerIcon"
    }
  }, [_vm._v("Положение")]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-uicons"
  }, [_c('div', {
    staticClass: "logo-maker-uicons__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconPosition),
      expression: "iconPosition"
    }],
    staticClass: "logo-maker-uicons__radio",
    attrs: {
      "type": "radio",
      "value": "left",
      "id": "logoMakerIconPosition_left"
    },
    domProps: {
      "checked": _vm._q(_vm.iconPosition, "left")
    },
    on: {
      "__c": function($event) {
        _vm.iconPosition = "left"
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-uicons__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconPosition),
      expression: "iconPosition"
    }],
    staticClass: "logo-maker-uicons__radio",
    attrs: {
      "type": "radio",
      "value": "top",
      "id": "logoMakerIconPosition_top"
    },
    domProps: {
      "checked": _vm._q(_vm.iconPosition, "top")
    },
    on: {
      "__c": function($event) {
        _vm.iconPosition = "top"
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-uicons__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconPosition),
      expression: "iconPosition"
    }],
    staticClass: "logo-maker-uicons__radio",
    attrs: {
      "type": "radio",
      "value": "right",
      "id": "logoMakerIconPosition_right"
    },
    domProps: {
      "checked": _vm._q(_vm.iconPosition, "right")
    },
    on: {
      "__c": function($event) {
        _vm.iconPosition = "right"
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-uicons__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconPosition),
      expression: "iconPosition"
    }],
    staticClass: "logo-maker-uicons__radio",
    attrs: {
      "type": "radio",
      "value": "bottom",
      "id": "logoMakerIconPosition_bottom"
    },
    domProps: {
      "checked": _vm._q(_vm.iconPosition, "bottom")
    },
    on: {
      "__c": function($event) {
        _vm.iconPosition = "bottom"
      }
    }
  }), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-menu__half",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('label', {
    staticClass: "logo-maker-menu__label",
    attrs: {
      "for": "logoMakerIcon"
    }
  }, [_vm._v("Размер")]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-uicons"
  }, [_c('div', {
    staticClass: "logo-maker-uicons__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconScale),
      expression: "iconScale"
    }],
    staticClass: "logo-maker-uicons__radio",
    attrs: {
      "type": "radio",
      "value": "0.75",
      "id": "logoMakerIconPosition_075"
    },
    domProps: {
      "checked": _vm._q(_vm.iconScale, "0.75")
    },
    on: {
      "__c": function($event) {
        _vm.iconScale = "0.75"
      }
    }
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-uicons__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconScale),
      expression: "iconScale"
    }],
    staticClass: "logo-maker-uicons__radio",
    attrs: {
      "type": "radio",
      "value": "1",
      "id": "logoMakerIconPosition_1"
    },
    domProps: {
      "checked": _vm._q(_vm.iconScale, "1")
    },
    on: {
      "__c": function($event) {
        _vm.iconScale = "1"
      }
    }
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-uicons__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconScale),
      expression: "iconScale"
    }],
    staticClass: "logo-maker-uicons__radio",
    attrs: {
      "type": "radio",
      "value": "1.5",
      "id": "logoMakerIconPosition_15"
    },
    domProps: {
      "checked": _vm._q(_vm.iconScale, "1.5")
    },
    on: {
      "__c": function($event) {
        _vm.iconScale = "1.5"
      }
    }
  }), _vm._v(" "), _vm._m(6)])])])]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-menu__item"
  }, [_c('label', {
    staticClass: "logo-maker-menu__label",
    attrs: {
      "for": "logoMakerIcon"
    }
  }, [_vm._v("Рамка")]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-icons logo-maker-icons--shape",
    staticStyle: {
      "max-height": "197px"
    }
  }, _vm._l((_vm.shapes), function(i) {
    return _c('div', {
      staticClass: "logo-maker-icons__item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.shape),
        expression: "shape"
      }],
      staticClass: "logo-maker-icons__radio",
      attrs: {
        "type": "radio",
        "id": 'logoMakerShape_' + i
      },
      domProps: {
        "value": i,
        "checked": _vm._q(_vm.shape, i)
      },
      on: {
        "__c": function($event) {
          _vm.shape = i
        }
      }
    }), _vm._v(" "), (i == 'none') ? _c('label', {
      staticClass: "logo-maker-icons__icon",
      attrs: {
        "for": 'logoMakerShape_' + i
      }
    }, [_c('div', {
      staticStyle: {
        "width": "45px",
        "height": "45px",
        "color": "#000",
        "font-weight": "bold",
        "line-height": "45px",
        "text-align": "center"
      }
    }, [_vm._v("Нет")])]) : _c('label', {
      staticClass: "logo-maker-icons__icon",
      attrs: {
        "for": 'logoMakerShape_' + i
      }
    }, [_c('img', {
      attrs: {
        "alt": "",
        "src": 'static/shapes/' + i + '.svg',
        "width": "42",
        "height": "42"
      }
    })])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-workarea-wrap"
  }, [_c('div', {
    staticClass: "logo-maker-workarea",
    attrs: {
      "id": "logoMakerWorkarea"
    }
  }, [_c('svg', {
    staticClass: "logo-maker-svg"
  }, [_c('g', {
    staticClass: "logo-maker-svg__inner"
  }, [_c('text', {
    style: ({
      fontWeight: _vm.textBold ? 'bold' : 'normal',
      fontStyle: _vm.textItalic ? 'italic' : 'normal',
      fontSize: _vm.textStyle.fontSize,
      fontFamily: '\'' + _vm.textStyle.fontFamily + '\''
    }),
    attrs: {
      "text-anchor": "middle",
      "fill": _vm.textColor,
      "transform": _vm.textTransform
    }
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), (!_vm.hasShape()) ? _c('g', {
    staticClass: "icon-wrap",
    attrs: {
      "transform": _vm.iconTransform,
      "fill": _vm.iconColor
    },
    domProps: {
      "innerHTML": _vm._s(_vm.iconHTML)
    }
  }) : _c('g', {
    staticClass: "icon-wrap",
    attrs: {
      "transform": _vm.iconTransform,
      "fill": _vm.iconColor
    }
  }, [_c('g', {
    attrs: {
      "transform": "matrix(0.8, 0, 0, 0.8, 22, 22)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.iconHTML)
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "x": "0",
      "y": "0",
      "transform": "matrix(1, 0, 0, 1, 0, 0)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.shapePath)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-info"
  }, [_c('div', {
    staticClass: "logo-maker-get-logo"
  }, [_c('button', {
    staticClass: "logo-maker-get-logo__btn",
    on: {
      "click": _vm.getLogo
    }
  }, [_vm._v("Забрать свой логотип")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-width": "520px"
    }
  }, [_vm._v("\n          Конструктор логотипов - инструмент, который позволит вам создать профессиональный логотип вашей компании в считанные минуты - даже если у вас нет навыков работы в графических редакторах.\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "logo-maker-uicons__label",
    attrs: {
      "for": "logoMakerIconPosition_left"
    }
  }, [_c('img', {
    staticClass: "logo-maker-uicons__icon",
    attrs: {
      "src": "static/ui-icons/ui_left.svg",
      "alt": "left",
      "title": "left"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "logo-maker-uicons__label",
    attrs: {
      "for": "logoMakerIconPosition_top"
    }
  }, [_c('img', {
    staticClass: "logo-maker-uicons__icon",
    attrs: {
      "src": "static/ui-icons/ui_top.svg",
      "alt": "top",
      "title": "top"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "logo-maker-uicons__label",
    attrs: {
      "for": "logoMakerIconPosition_right"
    }
  }, [_c('img', {
    staticClass: "logo-maker-uicons__icon",
    attrs: {
      "src": "static/ui-icons/ui_right.svg",
      "alt": "left",
      "title": "left"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "logo-maker-uicons__label",
    attrs: {
      "for": "logoMakerIconPosition_bottom"
    }
  }, [_c('img', {
    staticClass: "logo-maker-uicons__icon",
    attrs: {
      "src": "static/ui-icons/ui_bottom.svg",
      "alt": "bottom",
      "title": "bottom"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "logo-maker-uicons__label",
    attrs: {
      "for": "logoMakerIconPosition_075"
    }
  }, [_c('img', {
    staticClass: "logo-maker-uicons__icon",
    attrs: {
      "src": "static/ui-icons/ui_size1.svg",
      "alt": "0.75",
      "title": "0.75"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "logo-maker-uicons__label",
    attrs: {
      "for": "logoMakerIconPosition_1"
    }
  }, [_c('img', {
    staticClass: "logo-maker-uicons__icon",
    attrs: {
      "src": "static/ui-icons/ui_size2.svg",
      "alt": "1",
      "title": "1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "logo-maker-uicons__label",
    attrs: {
      "for": "logoMakerIconPosition_15"
    }
  }, [_c('img', {
    staticClass: "logo-maker-uicons__icon",
    attrs: {
      "src": "static/ui-icons/ui_size3.svg",
      "alt": "1.5",
      "title": "1.5"
    }
  })])
}]}

/***/ })

},[44]);


// WEBPACK FOOTER //
// static/js/app.785e2dc9b5844aff7861.js